import { render, staticRenderFns } from "./SmartStoresMovement.vue?vue&type=template&id=3bef3b42&scoped=true&"
import script from "./SmartStoresMovement.vue?vue&type=script&lang=js&"
export * from "./SmartStoresMovement.vue?vue&type=script&lang=js&"
import style0 from "./SmartStoresMovement.vue?vue&type=style&index=0&id=3bef3b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef3b42",
  null
  
)

export default component.exports